import {useIsFetching} from "react-query";
import {Spinner} from "react-bootstrap";

export default function LoadingSpinner({className}: {className: string}) {
    const isFetching = useIsFetching();
    if(!isFetching) return null;
    return <Spinner className={className} animation="border" role="status">
        <span className="sr-only">Loading...</span>
    </Spinner>
}